<div
  class="info-label-container"
  [class]="{
    'info-label-default': size() === InfoLabelSize.default,
    'info-label-large': size() === InfoLabelSize.large,
    'info-label-small': size() === InfoLabelSize.small,
  }">
  @if (leadingIconName()) {
    <div class="info-label-icon-container">
      <mat-icon class="info-label-icon flex-shrink-0" [svgIcon]="leadingIconName() ?? ''"></mat-icon>
    </div>
  }
  <div class="info-label-text">
    <ng-content></ng-content>
  </div>
  @if (trailingIconName()) {
    <mat-icon class="info-label-icon flex-shrink-0" [svgIcon]="trailingIconName() ?? ''"></mat-icon>
  }
</div>
